<template>
	<div class="resource-ext-ui">
		<component
			v-for="c in resourceExtComponents()"
			:is="c.component"
			:key="c.pluginName + '-' + c.componentName"
			@update:addSnippet="updateAddSnippet($event)"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'ResourceExtUI',
	computed: {
		...mapGetters(['resourceExtComponents'])
	},
	methods: {
		updateAddSnippet(snippet) {
			this.$emit('update:addSnippet', snippet);
		}
	}
};
</script>
